<template>
  <div ref="chart"></div>
</template>

<script>
import * as d3 from 'd3';

export default {
  name: 'ChartLegend',
  props: {
    input: {
      type: String
      // default:
      // '{"data":[{"color":"#d7191c","label":"Below average X Above average inequality"},{"color":"#fdae61","label":"Above average X Above average inequality"},{"color":"#abd9e9","label":"Below average X Below average inequality"},{"color":"#2c7bb6","label":"Above average X Below average inequality"}]}',
      // '{"data":[{"color":"#d7191c","label":"Below average X","label2":"Above average inequality"},{"color":"#fdae61","label":"Above average X","label2":"Above average inequality"},{"color":"#abd9e9","label":"Below average X","label2":"Above average inequality"},{"color":"#2c7bb6","label":"Above average X","label2":"Above average inequality"}]}'
    },
    isDoubleLine: {
      type: Boolean,
      default: false
    }
  },
  // the component's data
  data () {
    return {
      margin: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      },
      color: {},
      vis: [],
      width: 15,
      label_font_style: 'sans-serif',
      label_font_size: 13
    };
  },
  // You can do whatever when the selected node changes
  watch: {
    selectedNode (newData, oldData) {
      console.log('The selected node changed...', newData, oldData);
    },
    input (newData, oldData) {
      this.initialize();
    }
  },
  mounted () {
    this.initialize();
  },
  methods: {
    getTextWidth: function (text, fontSize, fontStyle) {
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      context.font = fontSize + 'px ' + fontStyle;
      return context.measureText(text).width;
    },
    setNoDataText: function () {
      this.$refs.chart.innerHTML = '<p style="text-align: center;">NO DATA</p>';
    },
    onMouseOver: function (e, data) {
      console.log('e', e, data);
      this.$emit('sendMouseOver', data);
    },
    onMouseOut: function (e, data) {
      console.log('e', e, data);
      this.$emit('sendMouseOver', data);
    },
    initialize () {
      const self = this;
      let tempData;
      const marginTop = 17;
      try {
        tempData = JSON.parse(self.input);
      } catch (error) {
        self.setNoDataText();
        return;
      }
      let data;
      if (tempData && tempData.data) data = tempData.data;
      else {
        self.setNoDataText();
        return;
      }
      // let legendMaxWidth = 0;
      // data.forEach(function (d) {
      //   const temp = self.getTextWidth(
      //     d.label,
      //     self.label_font_size,
      //     self.label_font_style
      //   );
      //   legendMaxWidth = legendMaxWidth > temp ? legendMaxWidth : temp;

      //   if (self.isDoubleLine) {
      //     const temp = self.getTextWidth(
      //       d.label2,
      //       self.label_font_size,
      //       self.label_font_style
      //     );
      //     legendMaxWidth = legendMaxWidth > temp ? legendMaxWidth : temp;
      //   }
      // });
      const $chart = d3.select(self.$refs.chart);
      $chart.selectAll('*').remove();
      self.vis[0] = $chart
        .append('svg')
        // .attr('width', legendMaxWidth + this.width + 15)
        .attr('width', '100%')
        .attr('height', data.length * (this.width + 4) + marginTop * data.length)
        .append('g')
        .attr(
          'transform',
          'translate(' + self.margin.left + ',' + self.margin.top + ')'
        )
        .attr('fill', '#ccc');

      const nodeEnter = self.vis[0].selectAll('.legend').data(data).enter();
      // nodeEnter
      //   .append("rect")
      //   .attr("class", "legend")
      //   .attr("width", self.width)
      //   .attr("height", self.width)
      //   .attr("y", function (d, i) {
      //     return (self.width * i) + 4 * i;
      //   })
      //   .attr("fill", function (d) {
      //     return d.color;
      //   })
      //   .on('mouseover', (event, d)=>{
      //     // self.onMouseOver(event, d);
      //   })
      //   .on('mouseout', (event, d)=>{
      //     // self.onMouseOut(event, undefined);
      //   });

      nodeEnter
        .append('circle')
        .attr('cx', 8)
        .attr('r', 7)
        .attr('stroke', function (d) {
          return d.color;
        })
        .attr('fill', function (d) {
          return d.color;
        })
        .attr('cy', function (d, i) {
          return 8 + (self.width * i) + 17 * i + marginTop;
        });

      if (self.isDoubleLine) {
        nodeEnter
          .append('text')
          .attr('class', 'legend-text')
          .attr('dy', '1em')
          .style('font-family', self.label_font_style)
          .style('font-size', self.label_font_size)
          .attr('x', self.width + 5)
          .attr('y', function (d, i) {
            return self.width * i + 17 * i - 4 + (marginTop - 4);
          })
          .text(function (d) {
            return d.label;
          })
          .attr('fill', '#000')
          .on('mouseover', (event, d) => {
            // self.onMouseOver(event, d);
          })
          .on('mouseout', (event, d) => {
            // self.onMouseOut(event, undefined);
          });

        nodeEnter
          .append('text')
          .attr('class', 'legend-text')
          .attr('dy', '1em')
          .style('font-family', self.label_font_style)
          .style('font-size', self.label_font_size)
          .attr('x', self.width + 5)
          .attr('y', function (d, i) {
            return self.width * i + 17 * i - 4 + (marginTop + 8);
          })
          .text(function (d) {
            return d.label2;
          })
          .attr('fill', '#000')
          .on('mouseover', (event, d) => {
            // self.onMouseOver(event, d);
          })
          .on('mouseout', (event, d) => {
            // self.onMouseOut(event, undefined);
          });
      } else {
        nodeEnter
          .append('text')
          .attr('class', 'legend-text')
          .attr('dy', '1em')
          .style('font-family', self.label_font_style)
          .style('font-size', self.label_font_size)
          .attr('x', self.width + 5)
          .attr('y', function (d, i) {
            return (self.width * i) + 17 * i + marginTop - 1;
          })
          .text(function (d) {
            return d.label;
          })
          .attr('fill', '#000')
          .on('mouseover', (event, d) => {
            // self.onMouseOver(event, d);
          })
          .on('mouseout', (event, d) => {
            // self.onMouseOut(event, undefined);
          });
      }
    }
  }
};
</script>

<style></style>
